import React from "react";
import { Link } from "react-router-dom";
import usePrasadamPolicy from "./customHooks";
import { Container, Grid } from "@mui/material";

function PrasadamPolicy() {
  const { data } = usePrasadamPolicy();
  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Prasadam Policy</h1>
        <ul className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/">Visit Info</Link>
          </li>
          <li className="breadcrumb-item active">Prasadam Policy</li>
        </ul>
      </Container>

      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            Temple
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Prasadam Policy</span>
          </h1>
        </Grid>

        <Grid className="row" px={2}>
          <div dangerouslySetInnerHTML={{ __html: data.description }} />
        </Grid>
      </Container>
    </>
  );
}

export default PrasadamPolicy;
